






























import { Component, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

@Component({
  components: {
    "store-provider": () =>
      import("@/components/app/global/baskets/basket/shop/storeProvider.vue"),
    "categories-list": () =>
      import("@/components/app/global/baskets/basket/shop/categoriesList.vue"),
    "products-list-wrapper": () =>
      import(
        "@/components/app/global/baskets/basket/shop/productsListWrapper.vue"
      )
  }
})
export default class ShopView extends Mixins(Context) {}
